<h1 class="mt-5" *ngIf="entrada" [routerLink]="['/mercaderies/entrada', ('000000' + entrada.idEntrada).slice(-6)]">Entrada: {{('000000' + entrada.idEntrada).slice(-6)}}</h1>

<div class="row mt-3">
    <div class="col-12 align-self-center">
        <p>
            Si vols accedir a alguna partida d'aquesta entrada introdueixa a continuació
        </p>
        <div class="alert alert-danger" *ngIf="error">{{error}}</div>
        <div class="form-group">
            <label for="partida-input"><b>Partida</b></label>
            <input id="partida-input" (ngModelChange)="partidaChange($event)" [(ngModel)]="partida" placeholder="000000" type="text" name="partida" class="form-control">
            <p class="text-danger" *ngIf="error">{{error}}</p>
        </div>
    </div>
</div>

<div class="row mt-3 text-center" *ngIf="pma">
    <div class="alert alert-danger w-100" role="alert">
        El PMA matrícula és superior a 7500 .El xofer no pot fer la càrrega/descàrrega.
    </div>
</div>

<div class="row mt-5">
    <div class="col-12">
        <p>
            A continuació pots adjuntar imatges de la entrada actual
        </p>
        <label for="file-entrada"><b>Foto</b></label>
        <input style="display:none;" id="file-entrada" #uploader type="file" name="document" (change)="uploadFile($event.target.files, $event)" class="form-control-file">
        <button class="btn btn-dark btn-block" (click)="uploader.click()">
            Pujar imatge <i class="fa fa-carrousel"></i>
        </button>
        <p class="text-danger" *ngIf="error">{{error}}</p>
    </div>

</div>


<hr>

<div class="row mb-3">
    <div class="col-6 mt-4" *ngFor="let document of documents">
        <img class="img-fluid" [src]="downloadUrl('entrades', document.id)">
    </div>
</div>

